import Store from './base';


type ResponseRates = {
  endDate: string;
  startDate: string;
  responseRates: {
    open: number;
    response: number;
    startDate: string;
    endDate: string;
  }[];
};

export default class ReportStore extends Store {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Store'.
  state: {
    responseRates: {
      data: ResponseRates | null | undefined;
      fetching: Promise<undefined> | null | undefined;
    };
  };

  constructor() {
    super('report');

    this.state = {
      responseRates: {
        data: null,
        fetching: null,
      },
    };
  }

  startFetching(promise: Promise<undefined>) {
    this.updateState({
      responseRates: {
        $assign: {
          fetching: promise,
        },
      },
    });
  }

  receiveFetched(data: ResponseRates) {
    this.updateState({
      responseRates: {
        $assign: {
          fetching: null,
          data,
        },
      },
    });
  }
}
